import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import axios from 'axios'
import moment from 'moment'

export default {
  data () {
      return {
        showTimeOut: false,
        interval: null,
        version: process.env.VUE_APP_VERSION,
        showRecommendRefresh: false,
        showForceRefresh: false,
        offline: false
      }
  },
  watch: {
    loggedIn () {
      if (!this.loggedIn) {
        if (this.$route.name !== "Login") {
          this.$router.push({ name: 'Login', query: { from: this.$route.fullPath } })
        }
      }
    }
  },
  computed: {
    ...mapGetters('auth', [
      'tokenExpires',
      'loggedIn',
      'lastActivity'
    ]),
    ...mapState('auth', [
      'user'
    ]),
    iconUrl () {
      if (process.env.NODE_ENV !== 'production' && (axios.defaults.params && axios.defaults.params['SUBDOMAIN'])) {
        return axios.defaults.baseURL + '/users/org/icon/?SUBDOMAIN=' + axios.defaults.params['SUBDOMAIN']
      } else {
        return axios.defaults.baseURL + '/users/org/icon/'
      }
    },
    logoUrl () {
      if (process.env.NODE_ENV !== 'production' && (axios.defaults.params && axios.defaults.params['SUBDOMAIN'])) {
        return axios.defaults.baseURL + '/users/org/logo/?SUBDOMAIN=' + axios.defaults.params['SUBDOMAIN']
      } else {
        return axios.defaults.baseURL + '/users/org/logo/'
      }
    }
  },
  methods: {
    ...mapActions('auth', {
      logOutAction: 'logOut',
      refreshAction: 'refreshToken',
      syncToken: 'syncToken',
      setLastActivity: 'setLastActivity'
    }),
    logOut () {
      this.logOutAction()
        .then(() => {
          this.$router.push({ name: 'Login', query: { from: this.$route.fullPath } })
        })
    }
  },
  created () {
    window.addEventListener("offline", () => {
      this.offline = true
    })
    window.addEventListener("online", () => {
      this.offline = false
    })
    axios.interceptors.response.use(response => {
      if (response.headers) {
        var minRequired = response.headers['x-cc-front-end-version'].split('/')[0]
        var minRecom = response.headers['x-cc-front-end-version'].split('/')[1]
        if (this.version < minRequired) {
          this.showForceRefresh = true
          return response
        }
        if (this.version < minRecom) {
          this.showRecommendRefresh = true
          return response
        }
      }
      return response
    }, undefined)
    if (this.$route.query.org) {
      localStorage.setItem('development-org', this.$route.query.org)
    }
    if (localStorage.getItem('development-org')) {
      axios.defaults.params = {}
      axios.defaults.params['SUBDOMAIN'] = localStorage.getItem('development-org')
    }
    let file = document.createElement('link')
    file.rel = 'stylesheet'
    if (process.env.NODE_ENV !== "production" && (axios.defaults.params && axios.defaults.params['SUBDOMAIN'])) {
      file.href = axios.defaults.baseURL + '/users/org/stylesheet/?SUBDOMAIN=' + axios.defaults.params['SUBDOMAIN']
    } else {
      file.href = axios.defaults.baseURL + '/users/org/stylesheet/'
    }
    document.head.appendChild(file)
    this.setLastActivity()
  },
  onIdle() {
    clearInterval(this.interval)
    this.interval = setInterval(() => {
      this.syncToken()
      if (!this.loggedIn)
        return
      var now = moment(new Date())
      var end = moment.unix(this.lastActivity)
      var duration = moment.duration(now.diff(end))
      var minutesLastActive = duration.asMinutes()
      if (minutesLastActive < 15) {
        if ((this.tokenExpires - (60000 * 1) < new Date()))
          this.refreshAction()
        this.showTimeOut = false
      } else if (minutesLastActive >= 15) {
        this.showTimeOut = true
      }
      if (this.tokenExpires < new Date()) {
        this.logOut()
        clearInterval(this.interval)
      }
    }, 1000)
  },
  onActive() {
    clearInterval(this.interval)
    this.interval = setInterval(() => {
      this.setLastActivity()
      this.showTimeOut = false
      if (this.loggedIn) {
        if ((this.tokenExpires - (60000 * 2.5) < new Date()) && this.loggedIn) {
          this.refreshAction()
        }
      }
    }, 1000)
  }
}
